import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { NgForm } from '@angular/forms';
import {Location } from '@angular/common';
import {LanguageService} from '../../services/language.service'; 
import {SiteuserService} from '../../services/siteuser.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  formArr={useremail:'',userpass:''};
  rqsSuccessSts :boolean;
  rqsFailSts :boolean;
  errmsg:string = '';
  errmsg_ar:string = '';
  isLoading:boolean;
  token:string;
  istest:boolean = false;
  wishlist:number;
  isloggedin:boolean;
  uname:string;
  showLang:string;
  
  constructor(private usrObj:SiteuserService, 
    private router:Router,private route:ActivatedRoute,
    private langObj:LanguageService,
    private location: Location) { 
      this.langObj.langStr.subscribe((data)=>{ 
        this.showLang = data;
      });
    }

  ngOnInit(): void {
    window.scroll(0,0);
    
    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }

    if(this.usrObj.loggedIn() == false){
      this.isloggedin = false;
    }else{
      this.isloggedin = true;
      this.uname = localStorage.getItem('sajuname');
    }

    this.route.params.subscribe((params:Params)=>{
      if(params['wishlist']){
        this.wishlist = params['wishlist'];
      }
    })



  }

  loginFormSubmit(frm:NgForm){

    this.isLoading = true;
    this.formArr.useremail = frm.value.useremail;
    this.formArr.userpass = frm.value.password;

    this.usrObj.siteuserLogin(this.formArr).subscribe((data:any)=>{
      this.isLoading = false;
      if (data.success){
         this.redirectsAfterLogin(data);
      }else{
        this.rqsFailSts = true;
        this.errmsg = data.data;
        this.errmsg_ar = data.data_ar;
      }
    },error=> {
      this.errmsg  = 'Internal Server Error.. You login could not be completed.';
      this.errmsg_ar = 'خطأ داخلي في الخادم .. لا يمكن إكمال تسجيل الدخول';
      this.rqsFailSts = true;
      this.isLoading = false;  
    });    
  }

  redirectsAfterLogin(data){
    this.token = data.token;
    this.rqsSuccessSts = true;
    this.rqsFailSts = false;
    localStorage.setItem('sajid', data.data.id);
    localStorage.setItem('sajuname', data.data.uName);
    localStorage.setItem('sajuemail', data.data.uEmail);
    localStorage.setItem('sajtoken', this.token); 
    if(this.wishlist == 1){
      this.location.back();
    }else{
      this.router.navigate(['my-account']);
    }
    
  }




}